export const PAGE_CONFIG = {
  "name": "OldInGameAnalytics",
};